import axiosIns from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSettings(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .get('settings', { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getUserById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getUserById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    uploadReport(ctx, quoteData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post('uploadReport', quoteData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },



    

  },
};
